import type { ITimelineEvent, ProviderCollectionInvoiceEvent } from '@enter/core';
import { CollectionInvoiceEventType } from '@enter/core/src/api/server/models/CollectionInvoiceEventType';
import { CollectionIntegrationType } from '@enter/core/src/api/server/models/CollectionIntegrationType';
import { formatDate } from '@enter/core/src/services/primitives/date-utils';
import { mdiExport } from '@mdi/js';

export function getCollectionInvoiceEvent(resource: ProviderCollectionInvoiceEvent): ITimelineEvent {
    const action = resource.eventType === CollectionInvoiceEventType.SENDSTATEMENT
        ? 'Enable Collections'
        : resource.eventType === CollectionInvoiceEventType.REMOVEFROMSTATEMENT
            ? 'Disable Collections'
            : 'Collection Event';
    const integration = resource.integrationType === CollectionIntegrationType.THIRDPARTY
        ? 'Third Party'
        : resource.integrationType === CollectionIntegrationType.INBOX
            ? 'Inbox Health'
            : resource.integrationType === CollectionIntegrationType.STATEMENT
                ? 'Statement'
                : 'Unknown';
    const status = !resource.submissionDate ? 'PENDING' : resource.errorDetails ? 'ERROR' : 'COMPLETE';

    return {
        id: resource.id,
        created: resource.created,
        event: 'Collection Event',
        icon: mdiExport,
        description: `${action} (${integration})`,
        statusTag: {
            label: status,
            tone: status === 'PENDING' ? 'pending' : status === 'ERROR' ? 'attention' : 'success',
        },
        kind: 'generic',
        type: 'Enter Admin',
        detailFields: [
            { label: 'ID', value: resource.id || '—' },
            { label: 'Event', value: action },
            { label: 'Integration', value: integration },
            { label: 'Status', value: status },
            { label: 'Request Date', value: resource.created ? formatDate(resource.created, 'MMM dd, yyyy hh:mm a') : '—' },
            { label: 'Completion Date', value: resource.submissionDate ? formatDate(resource.submissionDate, 'MMM dd, yyyy hh:mm a') : '—' },
            ...(resource.errorDetails ? [{ label: 'Error Details', value: resource.errorDetails }] : []),
        ],
    };
}
